var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "result-wrap"
  }, [_vm._v(" 12 ")]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };